const SESSION_STORE_KEY_AUTH = "Auth";
const SESSION_STORE_KEY_FINGERPRINT = "Fingerprint";

export function getGenericAuthModel(model) {
  return function() {
    let auth = sessionStorage.getItem(SESSION_STORE_KEY_AUTH);
    var authJson = null;

    if (auth != null) {
      authJson = JSON.parse(window.atob(auth));
    }

    if (authJson != null) {
      if (model == 'AUTH')
        return authJson;
      else
        return authJson[model];
    }
    if (model == 'UserInternal') return {
      Id: 1,
      Name: "Usuário",
      Identity: "",
      Email: "usuario@safe2pay.com.br",
      Phone: "51996459715",
      PictureUrl: ""
    };

    return undefined;
  };
}

export function setGenericItemBtoa(key) {
  return function(value) {
    sessionStorage.setItem(key, btoa(JSON.stringify(value)));
  };
}

export function setUserInternal(value) {
  const auth = sessionStorage.getItem(SESSION_STORE_KEY_AUTH);
  if (auth) {
    let newAuth = JSON.parse(window.atob(auth));
    if (newAuth) {
      newAuth.UserInternal = value;
      sessionStorage.setItem(SESSION_STORE_KEY_AUTH, btoa(JSON.stringify(newAuth)));
    }
  }
}

export function removeAuth() {
  sessionStorage.removeItem(SESSION_STORE_KEY_AUTH);
}

export function getFingerprint() {
  let fingerprint = sessionStorage.getItem(SESSION_STORE_KEY_FINGERPRINT);
  if (fingerprint != undefined && fingerprint != null) {
    return window.atob(fingerprint);
  }
  return undefined;
}

export function install(Vue) {
  Vue.prototype.$getAuth = getGenericAuthModel('AUTH');
  Vue.prototype.$getFingerprint = getFingerprint;
  Vue.prototype.$getTokenAuth = getGenericAuthModel('Token');
  Vue.prototype.$getUserInternal = getGenericAuthModel('UserInternal');
  Vue.prototype.$setAuth = setGenericItemBtoa(SESSION_STORE_KEY_AUTH);
  Vue.prototype.$setFingerprint = setGenericItemBtoa(SESSION_STORE_KEY_FINGERPRINT);
  Vue.prototype.$setUserInternal = setUserInternal;
  Vue.prototype.$removeAuth = removeAuth;
}


export default {
  install,
  getGenericAuthModel,
  removeAuth
};



// WEBPACK FOOTER //
// ./src/utils/sessionStoreAuth.js